import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Box } from '@mui/system';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography, Snackbar, Alert, FormControl, OutlinedInput, IconButton, InputAdornment } from '@mui/material';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LockIcon from '@mui/icons-material/Lock';
import { useDispatch } from 'react-redux';
import { userSignup } from '../../redux/actions/userAction';
import { useHistory } from 'react-router-dom';
export default function PasswordDialog({ open, setOpen, payload }) {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));


    //const dispatch = useDispatch();
    const [snack, setSnack] = useState(false);


    const [alert, setAlert] = useState({
        message: "This is an alert message.",
        severity: "success",
    })
    const handleClose = () => {
        setOpen(false);
    };
    const handleSnack = () => {
        setSnack(false);
    }

    const [password, setPassword] = useState({
        adminPass: "",
        confirmPass: ""
    })
    const handleChange = (prop) => (e) => {
        setPassword({ ...password, [prop]: e.target.value });
    }

    const register = (e) => {
        e.preventDefault()
        if (Object.keys(payload).length > 0) {
            if (!password.adminPass || !password.confirmPass) {
                setAlert({
                    message: "Please make sure to fill in the empty fields.",
                    severity: "warning"
                })
                setSnack(true)
            } else if (password.adminPass !== password.confirmPass) {
                setAlert({
                    message: "Please make sure you input the same passwords.",
                    severity: "error"
                })
                setSnack(true)
            } else {
                dispatch(userSignup("email", payload.userFirstName, payload.userLastName, payload.userAddress, payload.userEmail, payload.userContact, password.adminPass))
                history.push("/mybooks/reserve")
            }
        }
    }

    const history = useHistory();
    const dispatch = useDispatch();

    const style = {
        button: {
            textTransform: "none"
        },
        toggleButton: {
            border: 0,
            padding: 0,
            borderRadius: "50%",
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
        textField: {
            minWidth: matches ? 400 : 300,
            '& label.Mui-focused': {
                color: (theme) => theme.palette.primary.main,
            },
            '& .MuiOutlinedInput-root': {
                fontStyle: "italic",
                borderRadius: 7,
                '&.Mui-focused fieldset': {
                    border: "3px black solid",
                },
            },
        },
    }
    const vertical = fullScreen ? "bottom" : "top";
    const horizontal = "center";
    const [visibility, setVisibility] = useState(false);
    const handleClickShowPassword = () => {
        setVisibility((prev) => !prev);
    };

    return (
        <Box>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{ maxWidth: 500, margin: "auto" }}
            >
                <Snackbar open={snack} autoHideDuration={6000} onClose={handleSnack} anchorOrigin={{ vertical, horizontal }}>
                    <Alert onClose={handleSnack} severity={alert.severity} sx={{ width: '100%' }}>
                        {alert.message}
                    </Alert>
                </Snackbar>
                <DialogTitle id="responsive-dialog-title">
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <LockIcon />
                        <Typography variant='h5' fontWeight="bold" sx={{ color: (theme) => theme.palette.text.primary }}>
                            Enter Password
                        </Typography>
                    </Stack>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ marginBottom: 2 }}>
                        Make sure to use a secured password with more than six (6) characters.
                    </DialogContentText>
                    <Stack direction="column" spacing={1}>
                        <FormControl fullWidth variant="outlined" sx={style.textField}>
                            <OutlinedInput
                                id="password"
                                autoComplete="current-password"
                                fullWidth
                                type={visibility ? "text" : "password"}
                                value={password.adminPass}
                                onChange={handleChange("adminPass")}
                                inputProps={{ style: { textAlign: 'center', fontSize: 17 } }}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password "
                                            onClick={handleClickShowPassword}
                                            edge="end"
                                        >
                                            {visibility ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <FormControl fullWidth variant="outlined" sx={style.textField}>
                            <OutlinedInput
                                id="password"
                                autoComplete="current-password"
                                fullWidth
                                type={visibility ? "text" : "password"}
                                value={password.confirmPass}
                                onChange={handleChange("confirmPass")}
                                inputProps={{ style: { textAlign: 'center', fontSize: 17 } }}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            edge="end"
                                        >
                                            {visibility ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose} sx={{ ...style.button, color: (theme) => theme.palette.text.secondary }}>
                        Cancel
                    </Button>
                    <Button onClick={register} autoFocus sx={style.button}>
                        Register
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}